import { render, staticRenderFns } from "./channelInvoice.vue?vue&type=template&id=143f7344&scoped=true&"
import script from "./channelInvoice.vue?vue&type=script&lang=js&"
export * from "./channelInvoice.vue?vue&type=script&lang=js&"
import style0 from "./channelInvoice.vue?vue&type=style&index=0&id=143f7344&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f7344",
  null
  
)

export default component.exports